import React from "react";

export default function Footer() {
  return (
    <footer className="mt-24 bg-yellow-100 border-t border-yellow-200">
      <div className="max-w-6xl mx-auto px-6 py-6 text-center">
        <p className="text-sm text-gray-700">
          © {new Date().getFullYear()} Millie’s World ✨
        </p>

        <p className="text-sm text-gray-600 mt-1">
          Made with love for Millie 💛
        </p>
      </div>
    </footer>
  );
}
